import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HP/HomePage.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
    // 路由重新定向
    {
        path: '/',
        redirect: "/index"
    },
    // 登录页
    {
        path: '/login',
        name: 'LoginPage',
        component: () => import("@/views/Login/LoginPage.vue"),
    },
    // 首页
    {
        path: '/index',
        name: 'HomePage',
        component: HomePage,
        redirect: "/index",  // 重定向
        meta: {
            requiresAuth: true,
            content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        },
        children:[
            // 通讯录
            {
                path: '/index',
                name: '工作台',
                component: () => import("@/views/HP/indexPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 通讯录
            {
                path: '/address',
                name: '通讯录',
                component: () => import("@/views/HP/addressPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 岗位管理
            {
                path: '/position',
                name: '岗位管理',
                component: () => import("@/views/HP/positionPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 学习中心
            {
                path: '/learning',
                name: '学习中心',
                component: () => import("@/views/HP/learningPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
             // 学习中心  文件详情
             {
                path: '/learningDetail',
                name: '学习中心',
                component: () => import("@/views/HP/learningDetailPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 个人中心
            {
                path: '/userInfo',
                name: '个人中心',
                component: () => import("@/views/user/userInfoPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 一岗双责
            {
                path: '/todayWork',
                name: '今日工作',
                component: () => import("@/views/work/todayWorkPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/workbench',
                name: '工作台',
                component: () => import("@/views/work/workbenchPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 一岗双责  工作内容
            {
                path: '/workContent',
                name: '工作列表',
                component: () => import("@/views/work/workContentPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
                // 启用路由重复触发组件更新
                // props: route => ({
                //     cycle: route.query.cycle,
                //     dept_id: route.query.dept_id,
                //     jobs_id: route.query.jobs_id,
                //     pid: route.query.pid || 0
                // })
            },
            // 一岗双责  工作内容详情
            {
                path: '/workContentDetail',
                name: '工作内容详情',
                component: () => import("@/views/work/workContentDetailPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 一岗双责  工作记录  列表
            {
                path: '/workRecord',
                name: '工作记录',
                component: () => import("@/views/work/workRecordPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 一岗双责  工作记录  列表内容
            {
                path: '/workRecordContent',
                name: '工作记录',
                component: () => import("@/views/work/workRecordContentPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 一岗双责  工作记录  列表内容详情
            {
                path: '/workRecordContentDetail',
                name: '工作记录详情',
                component: () => import("@/views/work/workRecordContentDetailPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 一岗双责  工作记录  列表内容全部显示
            {
                path: '/workRecordContentAll',
                name: '工作记录',
                component: () => import("@/views/work/workRecordContentAllPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 一岗双责  工作管理  添加工作
            {
                path: '/workManagement',
                name: '工作管理',
                component: () => import("@/views/work/workManagementPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 专家  一岗双责  工作记录  列表内容全部显示
            {
                path: '/expertWorkbench',
                name: '工作清单',
                component: () => import("@/views/expert/workbenchPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 专家  通讯录  查看工作记录
            {
                path: '/expertWorkRecord',
                name: '工作记录',
                component: () => import("@/views/expert/workRecordPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // 专家  工作审核
            {
                path: '/expertWorkReview',
                name: '工作审核',
                component: () => import("@/views/expert/workReviewPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            // --------------------  专家  ---------------------------
            // --------------------  专家  ---------------------------
            // --------------------  专家  ---------------------------
            // --------------------  专家  ---------------------------
            // --------------------  专家  ---------------------------
            // 专家  用户管理
            {
                path: '/user_management',
                name: '用户管理',
                component: () => import("@/views/admin/user/managerPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/userDetail',
                name: '用户详情',
                component: () => import("@/views/admin/user/detailPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/dept',
                name: '部门管理',
                component: () => import("@/views/admin/dept_job/indexDept.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/job',
                name: '岗位管理',
                component: () => import("@/views/admin/dept_job/indexJob.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/risk',
                name: '风险管理',
                component: () => import("@/views/admin/risk_method/indexRisk.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/method_type',
                name: '措施类型',
                component: () => import("@/views/admin/risk_method/indexMethodType.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/method',
                name: '措施管理',
                component: () => import("@/views/admin/risk_method/indexMethod.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/work_content',
                name: '工作管理',
                component: () => import("@/views/admin/work/workManagementPage.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/risk_warning',
                name: '风险预警',
                component: () => import("@/views/admin/risk_warning/indexWarning.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/important_information',
                name: '重要资讯',
                component: () => import("@/views/admin/important_information/indexInfo.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/today_work',
                name: '今日作业',
                component: () => import("@/views/admin/today_work/indexWork.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/learning_center_type',
                name: '学习中心分类',
                component: () => import("@/views/admin/learning_center/indexType.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/learning_center_title',
                name: '学习资料',
                component: () => import("@/views/admin/learning_center/indexTitle.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
            {
                path: '/learning_center_detail',
                name: '学习资料详情',
                component: () => import("@/views/admin/learning_center/detailFile.vue"),
                meta: {
                    requiresAuth: true,
                    content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
                },
            },
        ]
    },
   
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

// meta: {
  //   requiresAuth: true,
  //   content:"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
// },


const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err);
}

router.beforeEach((to, from, next) => {
    const isLoginRequired = to.matched.some(record => record.meta.requiresAuth)
    const isLogin = localStorage.getItem('isLogin')
  
    if ( isLoginRequired && !isLogin ) {
        next('/login') // 未登录则重定向到登录页面
    } else {
        // next()
        if (to.path !== from.path) {  
            store.commit('ADD_PATH', {  
                path: to.fullPath,  
                name: to.name  
            });  
        }  
        next();  
    }
})

router.afterEach((to, from) => {
    // 在路由切换后滚动到页面顶部
    console.log('路由切换',to.path,from.path);
    if (to.path !== from.path) {
        window.scrollTo(0, 0); // 将滚动条位置设置到页面最顶部
    }
})



export default router
